import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

// `className` styles the trigger wrapper, for callers whose layout sizes that box.
const TooltipControl = ({ message, children, className, ...other }) => {
	return (
		<OverlayTrigger
			{...other}
			overlay={<Tooltip id={`tooltip-bottom`}>{message}</Tooltip>}
		>
			<div className={className}>{children}</div>
		</OverlayTrigger>
	)
}

export default TooltipControl
